import React from "react";
import Field from "@/components/post-ad/Field";

/**
 * Collapsible "Secondary contact" block — name/phone/whatsapp/email/photo
 * for a co-agent or partner. Serialised into `attributes` by the parent
 * before submit so buyers see it on the ad detail contact card.
 */
export default function SecondaryContactSection({ form, set, uploadSecondaryContactPhoto }) {
  return (
    <details className="rounded-2xl bg-slate-50 border border-soft p-4">
      <summary className="cursor-pointer font-display font-bold text-slate-800 text-sm">
        Secondary contact (optional)
      </summary>
      <p className="mt-3 text-xs text-slate-500">
        Show a second contact person on your ad (e.g. co-agent or partner). Buyers will see these
        details after they click &quot;Contact&quot;.
      </p>
      <div className="mt-4 grid md:grid-cols-2 gap-3">
        <Field label="Name">
          <input
            data-testid="post-ad-secondary-name"
            value={form.secondary_contact}
            onChange={(e) => set({ secondary_contact: e.target.value })}
            className="input"
          />
        </Field>
        <Field label="Phone">
          <input
            data-testid="post-ad-secondary-phone"
            value={form.secondary_contact_phone}
            onChange={(e) => set({ secondary_contact_phone: e.target.value })}
            className="input"
          />
        </Field>
        <Field label="WhatsApp (with country code)">
          <input
            data-testid="post-ad-secondary-whatsapp"
            value={form.secondary_contact_whatsapp}
            onChange={(e) => set({ secondary_contact_whatsapp: e.target.value })}
            className="input"
            placeholder="+64 21 000 0000"
          />
        </Field>
        <Field label="Email">
          <input
            data-testid="post-ad-secondary-email"
            type="email"
            value={form.secondary_contact_email}
            onChange={(e) => set({ secondary_contact_email: e.target.value })}
            className="input"
          />
        </Field>
      </div>
      <div className="mt-3">
        <Field label="Photo (PNG or JPG, ≤ 2 MB)">
          <div className="flex items-center gap-3">
            {form.secondary_contact_photo && (
              <img
                src={form.secondary_contact_photo}
                alt="Secondary contact"
                data-testid="post-ad-secondary-photo-preview"
                className="w-16 h-16 rounded-full object-cover bg-white border border-soft"
              />
            )}
            <label className="rounded-full px-4 py-2 bg-slate-100 hover:bg-slate-200 text-sm font-semibold cursor-pointer transition-colors">
              {form.secondary_contact_photo ? "Replace photo" : "Upload photo"}
              <input
                type="file"
                accept="image/png,image/jpeg,image/webp"
                className="sr-only"
                data-testid="post-ad-secondary-photo-input"
                onChange={(e) => e.target.files?.[0] && uploadSecondaryContactPhoto(e.target.files[0])}
              />
            </label>
            {form.secondary_contact_photo && (
              <button
                type="button"
                onClick={() => set({ secondary_contact_photo: "" })}
                data-testid="post-ad-secondary-photo-remove"
                className="text-xs font-semibold text-red-500 hover:underline"
              >
                Remove
              </button>
            )}
          </div>
        </Field>
      </div>
    </details>
  );
}
